<template>
  <div class="bc-white padding-20 br-4">
    <div class="display-flex jc-space-between ai-center mb-20">
      <b class="fs-18">事故类型库</b>
      <el-button type="primary" icon="el-icon-plus" size="small" @click="add">新增</el-button>
    </div>
    <div class="display-flex jc-space-between ai-flex-start">
      <el-form :inline="true" size="small" v-model="searchForm">
        <el-form-item label="">
          <el-input
            placeholder="类型名称"
            clearable
            v-model="searchForm.label"
          ></el-input>
        </el-form-item>
        <el-form-item label="">
          <el-select
            class="width-140"
            clearable
            placeholder="请选择类型状态"
            v-model="searchForm.aging">
            <el-option
              v-for="item in option.type"
              :key="item.value"
              :label="item.label"
              :value="item.value">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="">
          <el-button type="primary" icon="el-icon-search" @click="getTableData">查询</el-button>
          <el-button icon="el-icon-refresh-left" @click="reset">重置</el-button>
        </el-form-item>
      </el-form>
    </div>
    <el-table
      border
      :data="tableData">
      <el-table-column
        align="center"
        prop="label"
        label="类型名称">
      </el-table-column>
      <el-table-column
        align="center"
        prop="startTime"
        label="启用日期">
        <template #default="{ row }">
          <span v-if="row.startTime">
          {{ $moment(row.startTime).format('YYYY-MM-DD')}}
          </span>
        </template>
      </el-table-column>
      <el-table-column
        align="center"
        prop="abolishTime"
        label="废止日期">
        <template #default="{ row }">
          <span v-if="row.abolishTime">
          {{ $moment(row.abolishTime).format('YYYY-MM-DD')}}
          </span>
        </template>
      </el-table-column>
      <el-table-column
        align="center"
        prop="typeSource"
        label="关联旧类型形式">
        <template #default="{row}">
          {{ filterType(row.typeSource) }}
        </template>
      </el-table-column>
      <el-table-column
        align="center"
        prop="oldTypeName"
        label="关联旧类型说明">
      </el-table-column>
      <el-table-column
        align="center"
        prop="nationalDesc"
        show-overflow-tooltip
        label="相关说明">
      </el-table-column>
      <el-table-column
        align="center"
        prop="status"
        label="状态">
        <template #default="{ row }">
          <el-button type="primary" size="small" plain v-if="row.status === 1">启用中</el-button>
          <el-button type="danger" size="small" plain v-if="row.status === 0">禁用中</el-button>
        </template>
      </el-table-column>
      <el-table-column
        align="center"
        prop="remark"
        label="备注">
      </el-table-column>
      <el-table-column
        align="center"
        width="120px"
        label="操作">
        <template #default="slotProps">
          <el-button @click="edit(slotProps.row)" type="text">编辑</el-button>
          <el-button @click="del(slotProps.row)" class="color-danger" type="text">删除</el-button>
        </template>
      </el-table-column>
    </el-table>
    <div class="display-flex fd-row-reverse mt-20">
      <!-- 表格数据的分页的功能 -->
      <el-pagination
        hide-on-single-page
        @current-change="(val) => {searchForm.page = val}"
        :current-page="searchForm.page"
        :page-size="searchForm.limit"
        background
        layout="total, prev, pager, next, jumper"
        :total="total">
      </el-pagination>
    </div>
    <el-dialog
      size="500px"
      :title="dialog.title"
      :visible.sync="dialog.show">
      <el-form
          class="diy-top-form"
          :model="dialog.form"
          ref="ruleForm"
          label-width="120px"
          label-position="top"
          :rules="rules"
         >
         <el-row>
           <el-col :span="12">
            <el-form-item
              label="类型名称"
              prop="label"
              :rules="{required: true, message: '请输入类型名称', trigger: 'blur'}">
              <el-input placeholder="请输入类型名称" v-model="dialog.form.label"></el-input>
          </el-form-item>
           </el-col>
           <el-col :span="12">
             <el-form-item label="类型来源" prop="typeSource" :rules="{required: true, message: '请选择类型来源', trigger: 'blur'}" class="ml-30">
               <el-select
                  class="width-percent-100"
                  clearable
                  placeholder="请选择类型来源"
                  v-model="dialog.form.typeSource"
                  @change="changeSource">
                  <el-option
                    v-for="item in option.typeSource"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value">
                  </el-option>
                </el-select>
             </el-form-item>
           </el-col>
         </el-row>
         <el-row>
           <el-col :span="12">
            <el-form-item
              label="启用日期"
              prop="startTime"
              :rules="{required: true, message: '请选择启用日期', trigger: 'blur'}">
              <el-date-picker
                class="width-percent-100"
                value-format="yyyy-MM-dd 00:00:00"
                v-model="dialog.form.startTime"
                type="date"
                placeholder="请选择启用日期">
              </el-date-picker>
          </el-form-item>
           </el-col>
           <el-col :span="12">
             <el-form-item label="相关旧类型" prop="oldTypeId" class="ml-30">
               <el-select
                  multiple
                  :disabled="dialog.form.typeSource === 1"
                  class="width-percent-100"
                  clearable
                  placeholder="请选择相关旧类型"
                  v-model="dialog.form.oldTypeId">
                  <el-option
                    v-for="item in option.oldType"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value">
                  </el-option>
                </el-select>
             </el-form-item>
           </el-col>
         </el-row>
         <el-row>
           <el-col :span="12">
              <el-form-item
                label="废止日期"
                prop="abolishTime"
                >
                <el-date-picker
                  :disabled="dialog.form.abolishNone === 1"
                  class="width-percent-80"
                  v-model="dialog.form.abolishTime"
                  type="date"
                  value-format="yyyy-MM-dd 23:59:59"
                  placeholder="请选择废止日期">
                </el-date-picker>
                <el-checkbox class="ml-20" :true-label="1" :false-label="0" v-model="dialog.form.abolishNone" @change="changeNode">暂无</el-checkbox>
            </el-form-item>
           </el-col>
           <el-col :span="12">
             <el-form-item label="类型启用状态" prop="status" :rules="{required: true, message: '请选择类型启用状态', trigger: 'blur'}" class="ml-30">
               <el-radio-group v-model="dialog.form.status">
                  <el-radio :label="1">启用</el-radio>
                  <el-radio :label="0">禁用</el-radio>
                </el-radio-group>
             </el-form-item>
           </el-col>
         </el-row>
          <el-form-item label="类型说明">
            <el-input :autosize="{minRows: 2, maxRows: 8}" type="textarea" v-model="dialog.form.nationalDesc" placeholder="请输入类型说明"></el-input>
          </el-form-item>
          <el-form-item label="备注：">
            <el-input :autosize="{minRows: 2, maxRows: 8}" type="textarea" v-model="dialog.form.remark" placeholder="请输入备注"></el-input>
          </el-form-item>
        </el-form>
      <template #footer>
        <el-button type="primary" @click="submit">确认</el-button>
        <el-button @click="dialog.show = false">取消</el-button>
      </template>
    </el-dialog>
  </div>
</template>

<script>
import _ from 'lodash';

export default {
  name: 'syType',
  components: {},
  props: {},
  data () {
    return {
      showUrl: '',
      typeList: [],
      searchForm: {
        label: '',
        aging: '',
        page: 1,
        limit: 10
      },
      option: {
        type: [
          {
            label: '现行有效',
            value: 1
          },
          {
            label: '已废止',
            value: 2
          }
        ],
        typeSource: [
          {
            label: '纯新增',
            value: 1
          },
          {
            label: '由旧类型更名',
            value: 2
          },
          {
            label: '由旧类型合并',
            value: 3
          },
          {
            label: '由旧类型拆解',
            value: 4
          },
          {
            label: '由旧类型范围调整',
            value: 5
          }
        ],
        oldType: []
      },
      tableData: [],
      total: 0,
      dialog: {
        show: false,
        title: '新增',
        form: {
          id: '',
          label: '',
          typeSource: '',
          startTime: null,
          oldTypeId: [],
          abolishTime: null,
          abolishNone: 0,
          status: 1,
          nationalDesc: '',
          remark: ''
        }
      },
      rules: {
        oldTypeId: [
          { trigger: 'blur', message: '请选择相关旧类型', required: true }
        ],
        abolishTime: [
          { required: true, message: '请选择废止日期', trigger: 'blur' }
        ]
      }
    }
  },
  filters: {},
  computed: {
    /**
     * 监听复杂数据类型的变换
     */
    _searchForm () {
      return JSON.parse(JSON.stringify(this.searchForm))
    }
  },
  watch: {
    _searchForm: {
      handler: function (newVal, oldVal) {
        if (newVal.page !== 1 && newVal.page === oldVal.page) {
          this.searchForm.page = 1;
        } else {
          this.getTableData()
        }
      },
      deep: true
    }
  },
  methods: {
    filterType (val) {
      for (const key of this.option.typeSource) {
        if (key.value === val) {
          console.log('label', key.label);
          return key.label
        }
      }
    },
    reset () {
      this.searchForm = {
        label: '',
        aging: '',
        page: 1,
        limit: 10
      }
    },
    changeSource (val) {
      console.log('查看是否经过Source');
      if (val === 1) {
        this.rules.oldTypeId[0].required = false
      } else {
        this.rules.oldTypeId[0].required = true
      }
    },
    changeNode (val, bol = true) {
      console.log('查看是否经过Node', val);
      if (bol) {
        this.dialog.form.abolishTime = null
      }
      if (val === 1) {
        this.rules.abolishTime[0].required = false
      } else {
        this.rules.abolishTime[0].required = true
      }
    },
    add () {
      this.dialog = {
        show: true,
        title: '新增',
        form: {
          id: '',
          label: '',
          typeSource: '',
          startTime: null,
          oldTypeId: [],
          abolishTime: null,
          abolishNone: 0,
          status: 1,
          nationalDesc: '',
          remark: ''
        }
      }
    },
    edit (row) {
      console.log('row', row);
      this.dialog = {
        show: true,
        title: '编辑',
        form: {
          id: row.id,
          label: row.label,
          typeSource: row.typeSource,
          startTime: row.startTime,
          oldTypeId: row.oldTypeId ? row.oldTypeId.split(',') : [],
          abolishTime: row.abolishTime,
          abolishNone: row.abolishNone,
          status: row.status,
          nationalDesc: row.nationalDesc,
          remark: row.remark
        }
      }
      this.changeSource(row.typeSource)
      this.changeNode(row.abolishNone, false)
    },
    del (row) {
      this.$confirm('此操作将永久删除该数据, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$api.fx.del({ id: row.id }).then(res => {
          this.$message.success('删除成功')
          this.searchForm.page = 1
          this.getTableData()
        })
      }).catch(() => {});
    },
    submit () {
      console.log('oldTypeId', this.dialog.form.oldTypeId);
      this.$refs.ruleForm.validate(valid => {
        if (valid) {
          if (this.dialog.form.id) {
            this.$api.fx.update({
              ...this.dialog.form,
              oldTypeId: this.dialog.form.oldTypeId.join(',')
            }).then(res => {
              this.$message.success('编辑成功')
              this.getTableData()
              this.dialog.show = false
            })
          } else {
            this.$api.fx.save({
              ...this.dialog.form,
              oldTypeId: this.dialog.form.oldTypeId.join(',')
            }).then(res => {
              this.$message.success('添加成功')
              this.searchForm.page = 1
              this.getTableData()
              this.dialog.show = false
            })
          }
        }
      })
    },
    getTableData: _.debounce(function () {
      const data = {
        pageNum: this.searchForm.page,
        pageSize: this.searchForm.limit,
        label: this.searchForm.label,
        aging: this.searchForm.aging
      }
      this.$api.fx.list(data).then(res => {
        this.tableData = res.list
        this.total = res.total
      })
    }, 500)
  },
  beforeCreate () {
  },
  created () {

  },
  beforeMount () {
  },
  mounted () {
    this.$api.fx.type().then(res => {
      this.typeList = res
    })
    this.$api.fx.typeAll().then(res => {
      this.option.oldType = res.map(item => ({
        label: item.label,
        value: item.id
      }))
    })
    this.getTableData()
  },
  beforeUpdate () {
  },
  updated () {
  },
  beforeDestroy () {
  },
  destroyed () {
  }
}
</script>

<style lang="scss" scoped>

</style>
